import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';
import { callFormatApi } from 'owa-editor/lib/utils/callFormatApi';
import { getTableFormat } from 'owa-editor/lib/utils/getTableFormat';
import { TableFormat } from 'roosterjs-editor-types';

export default function applyTableFormat(
    property: 'hasHeaderRow' | 'hasFirstColumn' | 'hasBandedColumns' | 'hasBandedRows',
    editorId: string
) {
    const format = getTableFormat(editorId);
    if (!format) {
        return;
    }
    format[property] = !format[property];
    executeTableFormat(editorId, format);
}

const executeTableFormat = (editorId: string, format: TableFormat) => {
    callEditorApi(editorId, 'focus');
    callFormatApi(editorId, 'formatTable', [format]);
};
